import { render, staticRenderFns } from "./info-screening-notes.vue?vue&type=template&id=32b1f8fc&scoped=true&"
import script from "./info-screening-notes.vue?vue&type=script&lang=js&"
export * from "./info-screening-notes.vue?vue&type=script&lang=js&"
import style0 from "./info-screening-notes.vue?vue&type=style&index=0&id=32b1f8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b1f8fc",
  null
  
)

export default component.exports